export default __webpack_public_path__ + "b0566c53d8b8f177743a758b6ec08715.svg";